import { HttpParams, HttpClient } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { New } from '../models/new';
import { HelperService } from './helper.service';
import { TranslationService } from './translation.service';
import {CITY} from "../tokens";

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  city: string;
  constructor(
    private translationService: TranslationService,
    private helperService: HelperService,
    private http: HttpClient,
    @Inject(CITY) private injectedCity: string) {
    this.city = this.injectedCity || this.helperService.getCity();
  }


  getLastNews(): Observable<New[]> {
    const language = this.translationService.language;

    return this.http.get(`${environment.API_URL}getLastNews/${this.city}/${language}`)
      .pipe(map(result => this.mapNews(result)));
  }

  latestNews(): Observable<any> {
    const params = new HttpParams()
      .set("city", this.city)
      .set("action", "ZavedeniaAppFirstPage");

    return this.http.get(environment.MOBIBLE_API_URL, { params: params });
  }

  private mapNews(input: any): New[] {

    const result = input.map(x => <New>{
      id: Number(x['id']),
      label: x['title'],
      author: x['author'],
      description: x['description'],
      dateCreated: moment(x['date_created']).locale('BG').format("LL"),
      filename: x['filename'],
      venueId: Number(x['zavedenia_id']),
      venueName: x['venueName']
    });

    return result;
  }
}
